import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

// Legacy redirect — tags management/browse was consolidated under
// `/$org/settings/tags/$tagId` (see specs/todos/2026-07-20-02-move-tags-management-into-settings.md).
// Kept so old bookmarks/deep links keep working; the `search` (entity-type
// tab, query, page) is preserved across the redirect.
const legacySearchSchema = z.object({
    type: z.enum(['all', 'asset', 'document', 'user', 'contract', 'issue', 'expense', 'conversation']).optional(),
    q: z.string().optional(),
    page: z.number().optional(),
})

export const Route = createFileRoute('/$org/tags/$tagCode')({
    validateSearch: legacySearchSchema,
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: '/$org/settings/tags/$tagId',
            params: { org: params.org, tagId: params.tagCode },
            search,
        })
    },
})
